module.exports = __webpack_public_path__ + "img/3.b11dbb67.png";